import { InsightsOverTimeBinDtoModelSelector } from '../../../models';

export const missedOrdersFragment = (selector: InsightsOverTimeBinDtoModelSelector) => selector.interval.value;
